import { render } from "./ApiV2.vue?vue&type=template&id=ae2f287a&scoped=true"
import script from "./ApiV2.vue?vue&type=script&lang=js"
export * from "./ApiV2.vue?vue&type=script&lang=js"

import "./ApiV2.vue?vue&type=style&index=0&id=ae2f287a&lang=css"
import "./ApiV2.vue?vue&type=style&index=1&id=ae2f287a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2f287a"]])

export default __exports__